import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { api } from "../../Frontend/Api/axios";
import ReactGA from "react-ga4";
import swal from "sweetalert";
import { getSubdomain } from '../../api/axios';

const AuthHandler = () => {
  
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const secretKey = searchParams.get('secretKey');
  const domain = getSubdomain() || process.env.REACT_APP_DEFAULT_DOMAIN || 'www';

  useEffect(() => {
    const handleAuth = async () => {
      try {
        
        if (token && email && secretKey) {
          const response = await api.post('/user/lookup-user', {
            email: email,
            subdomain: domain,
            secretKey: secretKey,
            token: token
          });
          
          if (response.data.token) {

            if (response?.data?.success === 1) {
              const user_id = response?.data?.user_id;
              const token = response?.data?.token;

              navigate(`/dashboard/?id=${user_id}&token=${token}&subuser=false`);
              ReactGA.gtag("event", "login_user", {
                user_id: user_id,
              });
              ReactGA.set({ userId: user_id });
            } else {
              swal("Error!", response?.data?.message || "Somthing went wrong with token!", "error", {timer: 2500, buttons: false});
              navigate('/account');
            }
          } else {
            swal("Error!", response?.data?.message || "Somthing went wrong with token!", "error", {timer: 2500, buttons: false});
            navigate('/account');
          }
        } else {
          swal("Error!","Missing required fields in URL!", "error", {timer: 2500, buttons: false});
          navigate('/account');
        }
      } catch (error) {
        console.error('Authentication error:', error);
        swal("Error!", error?.response?.data?.error || "Somthing went wrong!", "error", {timer: 2500, buttons: false});
        navigate('/account');
      }
    };

    handleAuth();
  }, [token, email, secretKey, navigate]);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default AuthHandler; 
